// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1603":"badda995c893ebb6","2888":"18745b6199323d6b"}[chunkId] + ".css";
};